import { FC } from "react";
import { useTranslation } from "react-i18next";
import { classNames } from "@/utils/Classnames";
import Tooltip from "@/components/atoms/Tooltip";
import { ReceptionSlot } from "@/types";
import styles from "@/components/molecules/ReceptionSlotGrid/styles.module.css";

export type SlotState = "open" | "partial" | "full" | "closed";

interface Props {
  slot: ReceptionSlot;
  state: SlotState;
  fractionLabel: string;
  fractionLabelFull: string;
  selected: boolean;
  onSelect: () => void;
}

const STATE_CLASS: Record<SlotState, string> = {
  open: styles.slotCardOpen,
  partial: styles.slotCardPartial,
  full: styles.slotCardFull,
  closed: styles.slotCardClosed,
};

/** One slot card in the delivery-slot grid — time, accepted-fraction label, and capacity/state. */
const SlotCard: FC<Props> = ({ slot, state, fractionLabel, fractionLabelFull, selected, onSelect }) => {
  const { t } = useTranslation();
  const selectable = state === "open" || state === "partial";

  return (
    <button
      type="button"
      className={classNames(
        styles.slotCard,
        STATE_CLASS[state],
        selectable ? styles.slotCardSelectableCursor : "",
        selected ? styles.slotCardSelected : ""
      )}
      disabled={!selectable}
      onClick={selectable ? onSelect : undefined}
      aria-pressed={selected}
    >
      <span className={styles.slotCardTime}>{slot.startTime.slice(0, 5)}</span>
      <Tooltip label={fractionLabelFull} disabled={fractionLabelFull === fractionLabel}>
        <span className={styles.slotCardFraction}>{fractionLabel}</span>
      </Tooltip>
      <span className={styles.slotCardStatus}>
        {t("orders:deliverySlotPicker.freeCount", { count: slot.remainingCapacity, max: slot.capacity })}
      </span>
    </button>
  );
};

export default SlotCard;
